<template>
  <div
    class="modal fade"
    v-bind:id="'ModalAddNewBaseAcc-' + getParentCode"
    tabindex="99"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-notify modal-info" role="document">
      <!--Content-->
      <div class="modal-content text-center">
        <!--Header-->
        <div class="modal-header d-flex justify-content-center">
          <p class="heading">ثبت سرفصل حساب جدید</p>
        </div>

        <!--Body-->
        <div class="modal-body px-4 py-2" style="height: 100%; overflow: auto">

          <p class="h6 mt-2 text-info">{{this.getTitel1}}</p>
          <p v-if="this.getTitel2 != ''" class="h7 mb-2 text-info">{{this.getTitel2}}</p>

          <div class="row">
            <!-- کادر نوع حساب -->
            <div class="col-12 mb-2 position-relative">
              <select
                id="selectNPerType"
                class="form-control text-center selectStyle"
                v-model="NewTbBaseAcc.NAccType"
                v-bind:disabled="getParentCode != 0"
              >
                <option
                  v-for="option in getNAccTypeData"
                  v-bind:key="option.NCode"
                  v-bind:value="option.NCode"
                >
                  {{ option.SDesc }}
                </option>
              </select>
              <i
                class="
                  fas
                  fa-file-alt fa-1x-half
                  position-absolute
                  iconStyle
                  MandatoryStyle
                "
                title="نوع حساب"
              ></i>
            </div>

            <!-- کادر کد حساب -->
            <div class="col-12 mb-2 position-relative">
              <input
                type="text"
                placeholder="کد حساب"
                class="form-control text-center"
                v-model="NewTbBaseAcc.NCode"
                autocomplete="off"
                style="direction: ltr"
                maxlength="3"
                v-bind:disabled="getParentCode != 0"
              />
              <i
                class="
                  fas
                  fa-qrcode fa-1x-half
                  position-absolute
                  iconStyle
                  MandatoryStyle
                "
                title="کد حساب"
                style="top: 25%"
              ></i>
            </div>

            <!-- کادر شرح حساب -->
            <div class="col-12 mb-2 position-relative">
              <input
                type="text"
                placeholder="شرح حساب"
                class="form-control text-center"
                v-model="NewTbBaseAcc.SDesc"
                autocomplete="off"
                maxlength="80"
                id="inputSDesc"
                v-on:keyup.enter="SaveNewBaseAcc()"
              />
              <i
                title="شرح حساب"
                class="
                  fas
                  fa-edit fa-1x-half
                  position-absolute
                  iconStyle
                  MandatoryStyle
                "
              ></i>
            </div>

            <template v-if="NewNAccType == 1 || NewNAccType == 2">
              <!-- کادر رقم بودجه -->
              <div class="col-12 mb-2 position-relative">
                <input
                  type="text"
                  placeholder="رقم بودجه"
                  class="form-control text-center"
                  v-model="NewTbBaseAcc.NBudget"
                  autocomplete="off"
                  style="direction: ltr"
                  maxlength="10"
                />
                <i
                  class="
                    fas
                    fa-money-bill-wave fa-1x-half
                    position-absolute
                    iconStyle
                  "
                  title="رقم بودجه"
                ></i>
              </div>

              <!-- کادر کد بودجه -->
              <div class="col-12 mb-2 position-relative">
                <input
                  type="text"
                  placeholder="کد بودجه"
                  class="form-control text-center"
                  v-model="NewTbBaseAcc.NBudgetCode"
                  autocomplete="off"
                  style="direction: ltr"
                  maxlength="10"
                />
                <i
                  class="
                    fas
                    fa-money-bill-alt fa-1x-half
                    position-absolute
                    iconStyle
                  "
                  title="کد بودجه"
                ></i>
              </div>

              <!-- کادر نوع مصرف منبع -->
              <div class="col-12 mb-2 position-relative">
                <select
                  id="selectOrg"
                  class="form-control text-center selectStyle"
                  v-model="NewTbBaseAcc.NUseType"
                >
                  <option
                    v-for="option in getNUseType"
                    v-bind:key="option.NUseTypeCode"
                    v-bind:value="option.NUseTypeCode"
                  >
                    {{ option.NUseTypeText }}
                  </option>
                </select>
                <i
                  class="fas fa-plug fa-1x-half position-absolute iconStyle"
                  title="نوع مصرف منبع"
                ></i>
              </div>

              <!-- کادر نوع اعتبار -->
              <div class="col-12 mb-2 position-relative">
                <select
                  id="selectOrg"
                  class="form-control text-center selectStyle"
                  v-model="NewTbBaseAcc.NCreditType"
                >
                  <option
                    v-for="option in getNCreditType"
                    v-bind:key="option.NCreditTypeCode"
                    v-bind:value="option.NCreditTypeCode"
                  >
                    {{ option.NCreditTypeText }}
                  </option>
                </select>
                <i
                  class="
                    far
                    fa-credit-card fa-1x-half
                    position-absolute
                    iconStyle
                  "
                  title="گروه"
                ></i>
              </div>

              <!-- کادر کد ارتباط -->
              <div class="col-12 mb-2 position-relative">
                <input
                  type="text"
                  placeholder="کد ارتباط"
                  class="form-control text-center"
                  v-model="NewTbBaseAcc.NUseState"
                  autocomplete="off"
                  style="direction: ltr"
                  maxlength="10"
                />
                <i
                  class="
                    fas
                    fa-network-wired fa-1x-half
                    position-absolute
                    iconStyle
                  "
                  title="کد ارتباط"
                ></i>
              </div>
            </template>

          </div>
        </div>

        <!--Footer-->
        <div class="modal-footer flex-center justify-content-between px-4" style="height: 15%">
          <a
            class="btn btn-info waves-effect waves-light"
            v-bind:class="checkConnectToServer ? 'disabled btn-pink': ''"
            v-on:click="SaveNewBaseAcc()"
            >
            <i v-if="checkConnectToServer" class="fas fa-sync fa-spin fa-1x ml-2"></i>
            ثبت سرفصل حساب جدید
            </a>
          <a
            class="btn btn-outline-info waves-effect waves-light"
            v-bind:class="checkConnectToServer ? 'disabled': ''"
            style="padding-top: 0.375rem; padding-bottom: 0.375rem"
            data-dismiss="modal"
            >انصراف</a
          >
        </div>
      </div>
      <!--/.Content-->
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddNewBaseAcc',
  props: ['ParentCode','Title1', 'Title2','NewChildCode','NewNAccType'],
  data() {
    return {
      // اطلاعات سرفصل حساب
      NewTbBaseAcc: {
        NYear: 1400, // سال
        NCode: "", // کد حساب
        SDesc: "", // شرح حساب
        NAccType: 0, // نوع حساب
        NBudget: "", // رقم بودجه
        NDebitSum: 0, // جمع بدهکار
        NCreditSum: 0, // جمع بستانکار
        NUserCode: 0, // کد کاربر ثبت کننده
        SDate: "", // تاریخ ثبت
        DTime: "", // ساعت ثبت
        NPerID: 0, // کد پرسنل
        NRemain1: 0, // باقیمانده 1
        NRemain2: 0, // باقیمانده 2
        NRemain3: 0,
        NRemain4: 0,
        NRemain5: 0,
        NRemain6: 0,
        NRemain7: 0,
        NRemain8: 0,
        NRemain9: 0,
        NRemain10: 0,
        NRemain11: 0,
        NRemain12: 0, // باقیمانده 12
        NBudgetCode: "", // کد بودجه
        NCreditType: 0, // نوع نوع اعتبار
        NUseType: 0, // نوع مصرف منبع
        NUseState: "", // کد ارتباط
      },
      // کنترل اتصال به سرور
      checkConnectToServer: false,
    };
  },
  computed: {
    // دریافت کد والد
    getParentCode(){
        return this.ParentCode;
    },
    // دریافت عبارت سربرگ
    getTitel1(){
        // this.setNewChildCode(this.NewChildCode);
        this.NewTbBaseAcc.NCode = this.NewChildCode;
        this.NewTbBaseAcc.NAccType = this.NewNAccType;
        return this.Title1;
    },
    getTitel2(){
        setTimeout(() => {
            $('#inputSDesc').focus();
        }, 500);
        return this.Title2;
    },
    // دریافت لیست انواع سرفصل حساب
    getNAccTypeData() {
      // دریافت لیست انواع سرفصل حساب
      let typedata = this.$store.getters.getNAccTypeData;
      if(this.ParentCode == 0){
        typedata = typedata.filter(function (item){
          return item.SDesc != "افتتاحیه" && item.SDesc != "اختتامیه";
        });
      }
      return typedata;
    },
    // دریافت لیست منبع مصرف
    getNUseType() {
      // دریافت لیست منبع مصرف
      return this.$store.getters.getNUseType;
    },
    // دریافت لیست نوع اعتبار
    getNCreditType() {
      // دریافت لیست نوع اعتبار
      return this.$store.getters.getNCreditType;
    },
  },
  methods: {
    // تنظیم کد سطر جدید
    setNewChildCode(value){
        this.NewTbBaseAcc.NCode = value;
    },
    // ذخیره تغییرات حساب کاربری
    async SaveNewBaseAcc() {
      // آیا نوع سرفصل حساب مشخص شده است ؟
      if (this.NewTbBaseAcc.NAccType != -1) {
        // آیا کد حساب مقدار دهی شده است ؟
        if (this.NewTbBaseAcc.NCode != "") {
          if (this.ParentCode == 0){
            if (!(this.NewTbBaseAcc.NCode >= 100 && this.NewTbBaseAcc.NCode <= 999)) {
              // در سطح حساب کل مجاز به ثبت کد خارج از بازه 100 تا 999 نیستید
              this.$store.dispatch("notify", {
                notText: "در سطح حساب کل مجاز به ثبت کد خارج از بازه 100 تا 999 نمی باشید !",
                timeOut: 3500,
              });
              return false;
            }
          }
          // آیا نام حساب ثبت شده است ؟
          if (this.NewTbBaseAcc.SDesc != "") {
            // اعلام اتصال به سرور
            this.checkConnectToServer = true;
            // دریافت توکن احراز هویت
            let token = await this.$store.getters.getUserData.token;
            // کد کاربری
            let NUserCode = await this.$store.getters.getUserData
            .NUserCode;
            // دریافت تاریخ ثبت
            this.NewTbBaseAcc.SDate =
            this.$store.getters.getPersianDateValue.PersianDate;
            // اصلاح دیتا
            if(this.NewTbBaseAcc.NBudget == ''){
                this.NewTbBaseAcc.NBudget = 0;
            }
            if(this.NewTbBaseAcc.NUseState == ''){
                this.NewTbBaseAcc.NUseState = 0;
            }
            // درج ساعت ثبت
            // چون فیلد مورد نظر از نوع
            // DateTime
            //  هست لذا باید فرمت
            // ISO
            // استفاده شود
            this.NewTbBaseAcc.DTime = new Date().toISOString();
            // درج کد کاربر جاری
            this.NewTbBaseAcc.NUserCode = NUserCode;
            // ثبت سرفصل حساب جدید در سرور
            await this.$store.dispatch("SaveNewBaseAccToServer", {
            NewTbBaseAcc: this.NewTbBaseAcc,
            token: token,
            });
            // بستن مودال ثبت سرفصل حساب جدید
            $("#ModalAddNewBaseAcc-" + this.getParentCode).modal("hide");
            // اعلام اعمال تغییرات به والد
            this.$emit("AddNewBaseAcc");
          } else {
            // ثبت نام حساب الزامی است
            this.$store.dispatch("notify", {
              notText: "عدم درج نام حساب : درج نام حساب الزامی است !",
              timeOut: 2500,
            });
          }
        } else {
          // ثبت کد حساب الزامی است
          this.$store.dispatch("notify", {
            notText: "عدم درج کد حساب : درج کد حساب الزامی است !",
            timeOut: 2500,
          });
        }
      } else {
        // ثبت نوع سرفصل حساب الزامی است
        this.$store.dispatch("notify", {
          notText:
            "عدم تعیین نوع سرفصل حساب : تعیین نوع سرفصل حساب الزامی است !",
          timeOut: 2500,
        });
      }
      // اعلام اتمام اتصال به سرور
      this.checkConnectToServer = false;
    },
  },
};
</script>

<style>
/* استایل آیکون کنار فیلدها */
.iconStyle {
  top: 18%;
  right: 0px;
  border-radius: 50%;
  background-color: #e6f2fd;
  border: 1px solid #ced4da;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}
/* استایل فیلدهای اجباری */
.MandatoryStyle {
  background-color: #fde6e6;
}
/* استایل انتخاب سطر */
.selectStyle {
  font-size: 12px;
  height: 38px;
}
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/ListBaseAcc/Components/AddNewBaseAcc.vue